
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import infoGetActions from '../../sagas/info';
import { getToken } from '../../reducers/auth';
import { getProjectKatuzeItems } from '../../reducers/project';

import IsknTelList from '../common/iskn/IsknTelList';

const IsknObjectListTel = ({data, isknDate, loading}) => {

    const dispatch = useDispatch();
    const infoActions = infoGetActions(dispatch);
    const token = useSelector(state => getToken(state.auth));
    const projectKatuzeItems = useSelector(state => getProjectKatuzeItems(state.project));

    const handleTelClick = (telId) => {
        infoActions.getObjectTeleso(
            token,
            projectKatuzeItems.map(item => item.kod),
            isknDate,
            telId
        );
    }

    return (
        <IsknTelList
            data={data}
            isknDate={isknDate}
            loading={loading}
            onClick={handleTelClick}
        />
    );
}

export default IsknObjectListTel;
